module.exports = __webpack_public_path__ + "img/face-review.8cb137d1.png";